import React, { ComponentType } from 'react'
import { createRoot } from 'react-dom/client'
import reapitConfig from './reapit.config.json'
import simplyConfig from './simply.config'
import { Globals } from './core/constants'

// Init global config
window.reapit = {
  config: {
    appEnv: 'local',
    connectClientId: '',
    connectOAuthUrl: '',
    connectUserPoolId: '',
    platformApiUrl: '',
    marketplaceUrl: '',
  },
}

window.simply = {
  config: {
    apiUrl: '',
  },
}

export const renderApp = (Component: ComponentType) => {
  const rootElement = document.querySelector('#root') || document.body
  const isDesktop = Boolean(window[Globals.ReapitMarketplace])
  const html = document.querySelector('html')

  if (isDesktop && html) {
    html.classList.add('is-desktop')
  }

  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(<Component />)
  }
}

const run = async () => {
  try {
    // Set the global config
    window.reapit.config = reapitConfig
    window.simply.config = simplyConfig

    // See https://stackoverflow.com/questions/64158705/ignore-certain-console-errors-warnings-in-react
    const warningsToSuppress = ['The "true" prop is deprecated and will be removed in the next major release.']

    console.warn = function filterWarnings(message?: any, ...optionalParams: any[]) {
      if (warningsToSuppress.some((x) => message.includes(x))) {
        // Suppress.
      } else {
        console.warn(message, ...optionalParams)
      }
    }

    console.log(`Simply API URL is ${window.simply.config.apiUrl}`)

    // I import the app dynamically so that the config is set on window and I avoid any
    // runtime issues where config is undefined
    const { default: App } = await import('./core/app')

    renderApp(App)
  } catch (error) {
    console.error('Cannot fetch config', error)
  }
}

// QQQ
// window[Globals.ReapitMarketplace] = {
//   appCode: null, //'BDF160053',
//   prpCode: null,
//   refCode: 'MKT230022',
// }

run()
